import { Popover as PopoverAntd } from 'antd';
import './Popover.scss';
import { useState } from 'react';
import { Divider } from 'antd';
import ButtonTertiaryLarge from '../ButtonTertiary/ButtonTertiaryLarge';

const Popover = ({ items, children, onClick, ...props }) => {
  const [open, setOpen] = useState(false);

  const handleClick = item => e => {
    e.stopPropagation();
    if (item.onClick) item.onClick();
    else if (onClick) onClick();
    setOpen(false);
  };

  const content = (
    <div className="flex flex-col self-stretch grow gap-[8px]">
      {items?.map((item, i) => (
        <>
          {item.diffGroup ? (
            <Divider type="horizontal" className="m-0 !p-0" />
          ) : null}
          <ButtonTertiaryLarge
            key={i}
            posIcon={item.posIcon}
            title={<span className="text-body-medium">{item.label}</span>}
            className={item.className ?? 'items-start justify-start'}
            style={item.style}
            onClick={handleClick(item)}
          />
        </>
      ))}
    </div>
  );
  return (
    <PopoverAntd
      open={open}
      classNames={{
        body: 'p-[8px]',
        root: 'rounded-[8px]',
      }}
      styles={{ root: { width: '300px' } }}
      trigger={'click'}
      content={content}
      title={null}
      onOpenChange={setOpen}
      getPopupContainer={() => document.body}
      {...props}
    >
      {children}
    </PopoverAntd>
  );
};

export default Popover;
